import { render } from "./Category.vue?vue&type=template&id=2e5228f7&scoped=true&ts=true"
import script from "./Category.vue?vue&type=script&lang=ts"
export * from "./Category.vue?vue&type=script&lang=ts"

import "./Category.vue?vue&type=style&index=0&id=2e5228f7&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yeliheng\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\yeliheng-blog\\blog-vue\\blog\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5228f7"]])

export default __exports__